<script>
  import { getContext } from "svelte";
  const { zScale, custom } = getContext("LayerCake");
  let {
    x,
    y,
    line_y_top,
    line_y_bottom,
    title,
    description,
    value,
    keyFormat = (k) => k,
    leftOffset = 0
  } = $props();

  let tooltipWidth = $state(200);
  let winWidth = $state(0);
  let alignLeft = $derived.by(() => {
    return x >= 225;
  });
</script>

<svelte:window bind:innerWidth={winWidth} />
<div
  class="tooltip-line"
  style:left="{x}px"
  style:top="{line_y_top}px"
  style:bottom="calc(100% - {line_y_bottom}px)"
></div>
<div
  class="tooltip"
  class:align-left={alignLeft}
  style:--tooltip-align="{x}px"
  style:--tooltip-top="{y}px"
  style:--left-offset="{leftOffset}px"
  bind:clientWidth={tooltipWidth}
>
  <div class="title">{title}</div>
  {#if description}
    <div class="description">{description}</div>
  {/if}

  <div class="value">${$custom.valueFormat.format(value)}</div>
</div>

<style>
  .tooltip-line {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 1px;
    border-left: solid 1px var(--color-black);
    pointer-events: none;
  }
  .tooltip {
    font-size: 13px;
    pointer-events: none;
    position: absolute;
    background: var(--color-white);
    padding: var(--spacing-4);
    border: solid 1px var(--color-gray-shade-light);
    margin-left: var(--spacing-2);
    margin-right: auto;
    width: 200px;
    left: var(--tooltip-align);
    top: var(--tooltip-top);
  }
  .tooltip.align-left {
    margin-left: auto;
    margin-right: var(--spacing-2);
    transform: translateX(calc(-100% - var(--spacing-2)));
    /* right: var(--tooltip-align); */
    /* left: none; */
  }
  .tooltip,
  .tooltip-line {
    transition:
      left 200ms ease-out,
      top 200ms ease-out;
  }
  .title {
    font-size: var(--font-size-normal);
    font-weight: var(--font-weight-bold);
    font-family: var(--font-family-sans-alt);
    margin-bottom: var(--spacing-2);
    margin-top: 0;
    margin-bottom: 0;
  }
  .description {
    margin-bottom: var(--spacing-2);
    font-style: italic;
  }
  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-left: solid 4px var(--border-color);
    padding-left: var(--spacing-1);
  }
  .row:not(:last-child) {
    border-bottom: solid 1px var(--color-gray-shade-lighter);
    padding-bottom: var(--spacing-1);
  }
  .row:not(:first-child) {
    padding-top: var(--spacing-1);
  }
  .value {
    font-weight: var(--font-weight-bold);
  }
  .key-swatch {
    display: inline-block;
    height: 12px;
    width: 4px;
    margin-right: var(--spacing-1);
  }
  @media (max-width: 768px) {
    .tooltip,
    .tooltip.align-left {
      left: calc(0px - var(--left-offset)) !important;
      transform: translate(0, calc(-100% - var(--spacing-2)));
      width: calc(100% + var(--left-offset));
      margin-left: 0;
      margin-right: 0;
    }
  }
</style>
